import { isCtaRunnable } from 'src/alerts/AlertCenter.functions';
import type { tLiveAlert } from 'src/alerts/AlertCenter.types';
import {
  isAlertClosedForSession,
  useSessionClosedAlertsVersion,
} from 'src/components/AlertCenter/AlertInPage.session';

/**
 * AGI-885 (hallazgo 15) — whether the critical card on screen carries a
 * button: there is a P0 winner, the user has not closed it this session, and
 * its copy keeps a CTA a surface can run (what `withActionableCta` leaves).
 *
 * Derived during render, never registered from an effect: a surface that
 * yields its primary to the card reads the answer in the same frame the card
 * paints, so a screen never shows two primaries, not even for one frame.
 */
export function useWideAlertShowsCta(wideAlert: tLiveAlert | null): boolean {
  // Subscribing is the point: a close changes no argument here, and the
  // in-page CTA must take the primary back the moment the card goes.
  useSessionClosedAlertsVersion();

  if (!wideAlert || isAlertClosedForSession(wideAlert.key)) return false;
  return isCtaRunnable(wideAlert.copy.cta);
}
